import Vue from "vue"
import Router from "vue-router"
import Home from "./views/Home.vue"

// 路由懒加载
const getComponent = (name) => () =>
    import (`./views/${name}.vue`);

Vue.use(Router);

export default new Router({
    mode: "hash",
    base: process.env.BASE_URL,
    routes: [{
            path: "/",
            name: "home",
            component: Home
        },
        {
            path: "/about",
            name: "about",
            component: getComponent('About')
        },
        {
            path: "/product",
            name: "product",
            component: getComponent('Product')
        },
        {
            path: "/contact",
            name: "contact",
            component: getComponent('Contact')
        }
    ]
});